module.exports = new __parcel__URL__("Error.b0f67bec.svg").toString();